import { createFileRoute } from "@tanstack/react-router"
import { CustomersImport } from "modules/customers/components/Import/CustomersImport"
import { CustomerListSearchSchema } from "routes/_base/_auth/customers/list/route"
import { z } from "zod"

const SearchSchema = z.object({
  importId: z.string().uuid().optional(),
})

export const Route = createFileRoute("/_base/_auth/customers/list/import")({
  validateSearch: SearchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { importId } = Route.useSearch()

  return (
    <CustomersImport
      importId={importId}
      onClose={() => {
        navigate({
          to: "/customers/list",
          search: CustomerListSearchSchema.parse({}),
        })
      }}
    />
  )
}
